module.exports = __webpack_public_path__ + "startpage-746fed5a/bewerbungsschreiben-praktikum-33e32859519d47c93b01e33b5d2dffeb.jpeg";